import { gql } from '@apollo/client';

export const ESIS_JOBS_INFO = gql`
  query jobsInfo(
    $page: Int
    $size: Int
    $searchTerm: String
    $importType: [String]
    $startTime: String
    $endTime: String
  ) {
    jobsInfo(
      page: $page
      size: $size
      searchTerm: $searchTerm
      importType: $importType
      startTime: $startTime
      endTime: $endTime
    ) {
      items {
        id
        status
        createdOn
        startTime
        endTime
        startedBy
        fileName
        importType
      }
      totalCount
    }
  }
`;

export const ESIS_JOBS_DETAIL = gql`
  query jobDetailsById($jobId: String!) {
    jobDetailsById(jobId: $jobId) {
      id
      name
      status
      createdOn
      startTime
      endTime
      startedBy
      fileName
      importType
    }
  }
`;

export const ESIS_JOBS_REPORT = gql`
  query jobReport(
    $jobId: String!
    $page: Int
    $size: Int
    $searchTerm: String
    $changeType: String
  ) {
    jobReport(
      jobId: $jobId
      page: $page
      size: $size
      searchTerm: $searchTerm
      changeType: $changeType
    ) {
      totalCount
      items {
        jobId
        correlationalId
        changeType
        errorMessage
        createdOn
        entityType
      }
    }
  }
`;

export const ESIS_JOBS_CHANGE_TYPE = gql`
  query jobChangeTypes($jobId: String!) {
    jobChangeTypes(jobId: $jobId)
  }
`;
